export default __webpack_public_path__ + "static/media/nft_default.3703b563.png";